import { render } from "./DaftarGESIAP.vue?vue&type=template&id=39496fe2"
import script from "./DaftarGESIAP.vue?vue&type=script&lang=js"
export * from "./DaftarGESIAP.vue?vue&type=script&lang=js"

import "./DaftarGESIAP.vue?vue&type=style&index=0&id=39496fe2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__